import { ICreateGroupPlayers, IGroupPlayers } from "@grassrootly/api/entities";
import withErrorCheck from "../CheckError";
import server from "../Server";

export const CreateGroupPlayer = async (payload: IGroupPlayers): Promise<Partial<ICreateGroupPlayers>[]> => {
  const inserted = withErrorCheck(
    await server
      .from("GroupPlayers")
      .insert({
        group_id: payload.group_id,
        player_id: payload.player_id,
        is_owner: true,
        created_at: payload.created_at,
      })
      .select()
  );

  if (inserted && inserted.length > 0) {
    return inserted.map((item) => ({
      group_id: item.group_id,
      player_id: item.player_id,
      is_owner: item.is_owner,
      created_at: item.created_at,
    }));
  } else {
    return [];
  }
};
